import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import {BrowserRouter, Link, Route, Routes, Outlet} from "react-router-dom";


import logo from './logo.svg';
import './App.css';
import CreateTale from "./Tales/CreateTale";
import Layout from "./Layout";
import Catalog from "./Catalog/Catalog";
import EditTale from "./Tales/EditTale";
import Login from "./Login";
import Karaoke from "./Karaoke/Karaoke";

function App() {
  return (
      <BrowserRouter>
          <div style={{backgroundColor: 'rgb(65, 72, 69)', minHeight: '100vh'}}>
                  <Routes>
                      <Route path="/admin/" element={<Login />} />
                      <Route path="/admin" element={<Layout />}>
                          <Route path="/admin/catalog" element={<Catalog />} />
                          <Route path="/admin/create" element={<CreateTale />} />
                          <Route path="/admin/karaoke" element={<Karaoke />} />
                          <Route path="/admin/edit/:id" element={<EditTale />} />
                      </Route>
                  </Routes>
          </div>

      </BrowserRouter>
    // <div className="App">
    //   <header className="App-header">
    //    <CreateTale />
    //   </header>
    // </div>
  );
}

export default App;
